import React from 'react'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'

const NotificationBar = ({ textNormal, textBold }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  return (
    <div style={styles.container}>
        <span>{textNormal} <i><b>{textBold}</b></i></span>
    </div>
  )
}

export default NotificationBar

